// 広告リンクはリファラを渡さないとASPのレポートで経由ページを特定できないため、noreferrer を付けない
export const SPONSORED_LINK_REL = "sponsored nofollow noopener";
